if (!customElements.get('cart-recommendation-card')) {
  customElements.define(
    'cart-recommendation-card',
    class CartRecommendationCard extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        try {
          this.variants = JSON.parse(this.querySelector('[data-cart-recommendation-variants]')?.textContent || '[]');
        } catch (error) {
          this.variants = [];
        }

        this.querySelectorAll('[data-cart-recommendation-option]').forEach((select) => {
          select.addEventListener('change', () => this.updateVariant());
        });
      }

      updateVariant() {
        const selectedOptions = Array.from(this.querySelectorAll('[data-cart-recommendation-option]')).map(
          (select) => select.value
        );
        const variant = this.variants.find((candidate) =>
          candidate.options.every((option, index) => option === selectedOptions[index])
        );

        this.applyVariant(variant || null);
      }

      applyVariant(variant) {
        const input = this.querySelector('[data-cart-recommendation-variant-id]');
        const button = this.querySelector('.cart-drawer-recommendations__submit');
        const buttonText = this.querySelector('[data-cart-recommendation-submit-text]');
        const price = this.querySelector('[data-cart-recommendation-price]');
        const comparePrice = this.querySelector('[data-cart-recommendation-compare-price]');
        const image = this.querySelector('[data-cart-recommendation-image]');

        if (!variant) {
          if (input) input.value = '';
          if (button) button.disabled = true;
          if (buttonText) buttonText.textContent = 'לא זמין';
          return;
        }

        if (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (button) button.disabled = !variant.available;
        if (buttonText) buttonText.textContent = variant.available ? 'הוספה' : 'אזל מהמלאי';
        if (price) price.textContent = variant.price;
        if (comparePrice) {
          comparePrice.hidden = !variant.hasCompareAtPrice;
          comparePrice.textContent = variant.hasCompareAtPrice ? variant.compareAtPrice : '';
        }
        if (image && variant.image) {
          image.removeAttribute('srcset');
          image.src = variant.image;
        }
      }
    }
  );
}

if (!customElements.get('cart-recommendation-mixer')) {
  customElements.define(
    'cart-recommendation-mixer',
    class CartRecommendationMixer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        const limit = Math.max(1, Number(this.dataset.recommendationLimit) || 3);
        const list = this.querySelector('.cart-drawer-recommendations__list');
        const cards = Array.from(this.querySelectorAll('cart-recommendation-card'));
        const collectionGroups = new Map();
        const fallbackCards = [];

        cards.forEach((card) => {
          const sourceCollection = card.dataset.sourceCollection || 'fallback';

          if (sourceCollection === 'fallback') {
            fallbackCards.push(card);
            return;
          }

          if (!collectionGroups.has(sourceCollection)) collectionGroups.set(sourceCollection, []);
          collectionGroups.get(sourceCollection).push(card);
        });

        const selectedCards = [];
        const selectedProductIds = new Set();
        const selectCard = (card) => {
          if (!card || selectedCards.length >= limit || selectedProductIds.has(card.dataset.productId)) return false;
          selectedCards.push(card);
          selectedProductIds.add(card.dataset.productId);
          return true;
        };

        const shuffledGroups = this.shuffle(Array.from(collectionGroups.values()));

        // Represent as many different cart collections as possible before filling remaining slots.
        shuffledGroups.forEach((group) => {
          const candidate = this.shuffle(group).find((card) => !selectedProductIds.has(card.dataset.productId));
          selectCard(candidate);
        });

        const remainingCollectionCards = this.shuffle(
          shuffledGroups.flat().filter((card) => !selectedProductIds.has(card.dataset.productId))
        );
        remainingCollectionCards.forEach((card) => selectCard(card));

        const remainingFallbackCards = this.shuffle(
          fallbackCards.filter((card) => !selectedProductIds.has(card.dataset.productId))
        );
        remainingFallbackCards.forEach((card) => selectCard(card));

        cards.forEach((card) => {
          card.hidden = true;
        });

        if (!selectedCards.length) return;

        this.shuffle(selectedCards).forEach((card) => {
          card.hidden = false;
          list?.appendChild(card);
        });

        // Change only the heading text (same font/color/CSS as before).
        // Fewer than 3 earrings may remain when other styles are already in
        // the cart. Any nonempty, all-earrings recommendation set qualifies.
        const heading = this.querySelector('.cart-drawer-recommendations__heading');
        if (heading) {
          const allRecommendationsAreEarrings = selectedCards.length > 0 &&
            selectedCards.every((card) => card.dataset.qualifyingEarring === 'true');
          const earringsInCart = Math.max(0, Number(this.dataset.qualifyingEarringsInCart) || 0);

          if (allRecommendationsAreEarrings && earringsInCart === 1) {
            heading.textContent = 'הוסף זוג נוסף וקבל את השלישי ב-1₪';
          } else if (allRecommendationsAreEarrings && earringsInCart === 2) {
            heading.textContent = 'איזה כיף! תוסיף לך זוג שלישי בשקל';
          } else {
            heading.textContent = '89% מהלקוחות הוסיפו גם';
          }
        }

        this.hidden = false;
      }

      shuffle(items) {
        const shuffledItems = [...items];

        for (let index = shuffledItems.length - 1; index > 0; index -= 1) {
          const randomIndex = Math.floor(Math.random() * (index + 1));
          [shuffledItems[index], shuffledItems[randomIndex]] = [shuffledItems[randomIndex], shuffledItems[index]];
        }

        return shuffledItems;
      }
    }
  );
}